import { render, staticRenderFns } from "./DataSecurity.vue?vue&type=template&id=e65ddf72&scoped=true"
import script from "./DataSecurity.vue?vue&type=script&lang=js"
export * from "./DataSecurity.vue?vue&type=script&lang=js"
import style0 from "./DataSecurity.vue?vue&type=style&index=0&id=e65ddf72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65ddf72",
  null
  
)

export default component.exports